import { useRouter } from 'next/router';
import React, { useState, useEffect, useRef } from 'react';
import Link from 'next/link';

function Dropdown (props, sectionCode, categoryCode) {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const router = useRouter();

  // const layerCloseEvent = useRef();

  const selectItem = (item) => {
    if (typeof props.onChange === 'function') {
      props.onChange(item);
    }
    setSelectedItem(item);
  };

  useEffect(() => {
    const firstCode = props.data.find(item => item.code === props.categoryCode);

    if (firstCode) {
      setSelectedItem(firstCode);
    }
  }, []);

  function layerOpen () {
    if (open === false) {
      document.getElementById('header').style.display = 'none';
      document.getElementById('footer').style.display = 'none';
      document.body.classList.add('body_scroll_none');
    } else {
      document.getElementById('header').style.display = 'block';
      document.getElementById('footer').style.display = 'block';
      document.body.classList.remove('body_scroll_none');
    }
    setOpen(!open);
  }

  function tabLayerClose () {
    // tab제어 뒤로가기
    document.getElementById('layerpopup').focus();
  }

  useEffect(() => {
    if (open === true) {
      document.getElementById('0layeritem').focus(); // 키보드 이벤트일때만
    }
  }, [open]);

  return (
    <>
      <div
        className={`category_linkselect_w ${open ? 'current' : ''}`} onClick={() => layerOpen()}>
        <h3 className='cl_title' id='dropdown-box'>
          <a
            id='layerpopup'
            className='cl_link' role='button' aria-labelledby={(selectedItem) ? selectedItem.text : props.data[0].text} aria-expanded={`${open ? 'true' : 'false'}`}
            href='#'
          >

            <span className='cl_link_text'>{selectedItem?.text || ''}</span>
            <i className='category_icon_arrow'>
              <svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'>
                <path className='a' d='M5,1.809,8.783,5.78a.688.688,0,0,0,1.009,0,.783.783,0,0,0,0-1.062L5.508.218A.689.689,0,0,0,4.523.2L.208,4.714a.781.781,0,0,0,0,1.062.688.688,0,0,0,1.009,0Z' transform='translate(10 6) rotate(180)' />
              </svg>
            </i>
          </a>
        </h3>

        {/* 해당부분 category_linkselect_inner  뭐가 문제인 지확인해보자 */}
        {/* <div className='category_linkselect_inner' style={{ position: 'absolute', zIndex: 200 }}> */}
        <div className='category_linkselect_inner'>
          {/* role='listbox' aria-labelledby='dropdown-box' */}
          {/* TODO 내용 확인해보자 */}
          <ul className='cl_list'>
            {props.data.map((item, index) => { // 값 만큼 뿌림
              const linkUrl = item.link?.outUrl
                ? { pathname: item.link.outUrl }
                : { pathname: router.pathname, query: { ...router.query, ...item?.link?.query } };
              const isNewTabOpen = !!item.link?.outUrl;

              return (
                <li
                  key={`dropdown_item_${index}`} className={`cll_inner${item.code === props.categoryCode ? ' current' : ''}`}
                  onClick={() => selectItem(item)}
                >
                  <Link href={linkUrl}>
                    <a className='cll_link' href='#' id={index + 'layeritem'}>{item.text}
                      {selectedItem?.code === item.code && <i className='hide'>선택됨</i>}
                    </a>
                  </Link>
                </li>
              );
            })}
          </ul>
          <div className='cl_close_button'>
            {/* 닫기 이벤트 추가하기 */}
            <button className='cl_close_inner' onKeyPress={(e) => tabLayerClose()}>
              <i className='cl_close_icon'>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'><g transform='translate(-164.018 -178.02)'><g transform='translate(164.018 178.018)'><path className='a' d='M19.467,2.012.832,2.273a.915.915,0,0,1-.833-1H0A.979.979,0,0,1,.86.24L19.5-.021a.915.915,0,0,1,.833,1h0A.979.979,0,0,1,19.467,2.012Z' transform='translate(1.608 0.017) rotate(45)' /><path className='a' d='M19.47.261.834,0a.915.915,0,0,0-.833,1H0A.979.979,0,0,0,.862,2.034l18.636.26a.915.915,0,0,0,.833-1h0A.979.979,0,0,0,19.47.261Z' transform='translate(15.999 1.623) rotate(135)' /></g></g></svg>
                <span className='hide'>닫기</span>
              </i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dropdown;
